module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon15.png?999a8743";